import { setAccessToken } from './tokenService';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

/**
 * Step 1: Check Redis for existing valid session
 */
export async function checkCandidateSession(email) {
  const response = await fetch(`${API_BASE}/auth/candidate/session/check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    return { valid: false, has_active_exam: false, user: null, blocked: false, reason: null, access_status: null };
  }

  return response.json();
}

/**
 * Step 2: Authenticate candidate via Cognito (called only if Redis miss)
 */
export async function candidateLogin(email, password) {
  const response = await fetch(`${API_BASE}/auth/candidate/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Login failed');
  }

  return response.json();
}

/**
 * Handle NEW_PASSWORD_REQUIRED challenge
 */
export async function candidateSetPassword(username, newPassword, session) {
  const response = await fetch(`${API_BASE}/auth/candidate/set-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, new_password: newPassword, session }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to set password');
  }

  return response.json();
}

/**
 * Candidate logout - clears Redis session
 */
export async function candidateLogout(email) {
  try {
    await fetch(`${API_BASE}/auth/candidate/logout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
  } catch {
    // Ignore errors on logout
  }
}

/**
 * SSO login — uses MSAL PublicClientApplication (PKCE, no client secret)
 */
export { loginRedirect as initiateSSO } from './msalService';

/**
 * Logout - clears tokens
 */
export async function logout() {
  try {
    await fetch(`${API_BASE}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // Ignore errors on logout
  }
  setAccessToken(null);
}
